import request from '@/server/request'
import { API_JAVA } from '@/utils/base'

// 获取行业资讯分类
export async function GetIndustryNewsClassList (params) {
  return request(`${API_JAVA}/tmr/index/info/category`, {
    method: 'GET',
    params: params
  })
}

// 获取行业资讯列表
export async function GetIndustryInfoList (params) {
  return request(`${API_JAVA}/tmr/index/info/list`, {
    method: 'GET',
    params: params
  })
}

// 获取行业资讯详情
export async function GetIndustryInfoDetail (id, params) {
  return request(`${API_JAVA}/tmr/index/info/detail/${id}${params.type !== '' && params.type !== undefined ? '?type=' + params.type : ''}`, {
    method: 'GET'
  })
}

// 新增资讯评论
export async function AddIndustryComment (params) {
  return request(`${API_JAVA}/tmr/index/info/comment`, {
    method: 'POST',
    data: params
  })
}

// 获取资讯评论列表
export async function GetIndustryCommentList (params) {
  return request(`${API_JAVA}/tmr/index/info/comment/list`, {
    method: 'GET',
    params: params
  })
}

// 获取实时行情品类
export async function GetQuotesClassList (params) {
  return request(`${API_JAVA}/tmr/index/category`, {
    method: 'GET',
    params: params
  })
}

// 获取实时行情列表
export async function GetQuotesInfoList (params) {
  return request(`${API_JAVA}/tmr/index/list/quotes`, {
    method: 'GET',
    params: params
  })
}

// 获取价格趋势
export async function GetPriceTrends (params) {
  return request(`${API_JAVA}/tmr/index/tendency`, {
    method: 'GET',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/industry.js